module.exports = __webpack_public_path__ + "img/stats-visual.259fe3dd.jpg";